/// <reference types="vite/client" />
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import uuid from "react-uuid";

export const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';

export const dynamicBaseQuery = (baseQueryArgs: any = {}) => {
    return async (args: any, api: any, extraOptions: any) => {
        const state = api.getState();
        const authToken = state.auth.token;

        const baseQuery = fetchBaseQuery({
            ...baseQueryArgs,
            baseUrl: baseURL+'/api/',
            prepareHeaders: (headers: any) => {
                headers.set('accept', 'application/json');
                headers.set('Request-ID', uuid());
                headers.set('Content-Type', 'application/json');
                headers.set('Authorization', authToken ? `Bearer ${authToken}` : '');
                return headers;
            },
        });
        return baseQuery(args, api, extraOptions);
    };
};